import { useQuery } from "@tanstack/react-query";
import { Probe } from "@theprelude/sdk";
import { queries } from "../lib/query-factory";
import { useAuthConfig } from "../stores/auth-store";

export function useEndpointsQuery<T = Probe[]>(
  days: number,
  select?: (data: Probe[]) => T,
) {
  const authConfig = useAuthConfig();
  return useQuery({
    ...queries.detect.endpoints(authConfig, days),
    select,
  });
}
export function useRecentEndpointQuery<T = Probe[]>(
  select?: (data: Probe[]) => T,
) {
  return useEndpointsQuery(90, select);
}

export const useEndpointIdsQuery = () =>
  useRecentEndpointQuery((data) => data.map((d) => d.endpoint_id));

export const useEndpointTagsQuery = () =>
  useRecentEndpointQuery((data) => [...new Set(data.flatMap((d) => d.tags))]);
